import { device } from "shared/constants/device";
import styled from "styled-components";

export const FormUserInfo = styled.form`
  width:553px;
  padding-right:24px;
  @media ${device.tablet} { 
    width:100%;
    border-left:none;
    padding: 0;
    font-size:14px;
    button{
      width: 100%;
    }
  }
`
export const UserInfoContainer = styled.div`
  padding: 16px 16px 16px 24px;
  border-left: 1px solid rgb(235, 235, 240);
  flex: 1 1 auto;
  @media ${device.tablet} { 
    margin-top: 20px;
    width:100%;
    border-left:none;
    padding: 0;
    font-size:14px;
  }
`
export const UserDateContainer = styled.div`
  display:flex;
  > * {
    width: calc((100% - 10px) / 3);
    margin-right:10px;
    &:nth-child(3){
      margin-right:0;
    }
  }
`
export const ItemUserInfoContainer = styled.div`
  display:flex;
  justify-content:between;
  align-content: center;
  align-items: center
`
export const ItemInfoContainer = styled.div`
  flex: 1 1 auto;
  display:flex;
  align-content: start;
  align-items: start;
  img{
    width:25px;
    margin-right:10px;
  }
`